$(document).on('hidden.bs.modal', '.modal#highlights_list', () => {
    $('.highlight-snippet[data-id]').show();
})
